import { render, staticRenderFns } from "./modal-payment-confirm.vue?vue&type=template&id=502afe14"
import script from "./modal-payment-confirm.vue?vue&type=script&lang=js"
export * from "./modal-payment-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports